<template>
    <keep-alive :include="cachedViews">
        <router-view :key="$route.name"/>
    </keep-alive>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {
                cachedViews: ['EdgeProductsPage']
            }
        },
        mounted() {
            window.addEventListener('unload',this.saveState);
        },
        methods:{
            saveState(){
                sessionStorage.setItem('state',JSON.stringify(this.$store.state))
            }
        }
    }
</script>